export const getWordEnding = (amount: number) => {
  let result = ''

  if (amount % 10 >= 2 && amount % 10 <= 4 && (amount % 100 < 10 || amount % 100 >= 20)) {
    result = 'а'
  } else if (!(amount % 10 == 1 && amount % 100 != 11)) {
    result = 'ов'
  }

  return result
}
